import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import LoadingComponent from "../../app/layout/LoadingComponent";
import {  Header,  Segment } from "semantic-ui-react";
import { useStore } from "../../app/stores/store";
import { Formik, Form } from "formik";
import MyTextInput from "../../app/common/form/MyTextInput";
import {MySelectInput, valor, MySelectInputEdiciones} from "../../app/common/form/MySelectInput";
import { toast, ToastContainer } from 'react-toastify';
import { ExoneracionesDetailFormValues, ExoneracionesListFormValues, ExoneracionesMod, ExoneracionesModFormValues } from "../../app/models/ExoneracionesMod";
import MyTextArea from "../../app/common/form/MyTextArea";
import './exoupdate.css'


interface Props {
    idControl: any
    dpis: any
}


export default observer(function UpdateExoneracion (props : Props) {
        
    const [condicion, setCondicion] = useState(false)
    const [aplica, setAplica]=useState(false);
    const {CCTOperacionStore, CuentaDPIStore} = useStore();
    const {createCCTOperacion, dpiByCodigo,  getTransacciones, TransaccionByCodigo, TransaccionRegistry, personaDPI, kk, inputPersona, CCTCuentaByCodigo} = CCTOperacionStore;

    const {CuotasStore, modalStore} = useStore();  
    const {ExoneracionesStore} = useStore();    

    const {createExoneracionMod, loadIdcontrol, loading, exoneracionDetail, transXCuenta } = ExoneracionesStore; 
    //const {CATCoursesInfo,testing} = CuotasStore;

   
    const {loadEditions,} = CuotasStore;
   
    const {loadExonDetail, updateExoneracionMod} =ExoneracionesStore;

    const [Exoneraciones, setExoneraciones] = useState<ExoneracionesDetailFormValues>(new ExoneracionesDetailFormValues());

    const [ExoneracioneS, setExoneracioneS] = useState<ExoneracionesModFormValues>(new ExoneracionesModFormValues());

    useEffect(() => {
        if (props.idControl) loadIdcontrol(props.idControl).then(Exoneraciones => setExoneraciones(new ExoneracionesDetailFormValues()))
 }, [props.idControl, loadIdcontrol]);
  

useEffect(() =>{
     
 
 
   }, []);
       
    const [ExoneracionMod ] = useState<ExoneracionesModFormValues>(new ExoneracionesModFormValues());
    const [ExoneracionesDetail ] = useState<ExoneracionesDetailFormValues>(new ExoneracionesDetailFormValues());

    
    let Nombres : string 
    let actividad: string
    let trans: string 
    let razon: string = ""
    let porcentaje: any = ""
    let codigo: any
    let idalumno: any
    let idaprobado: any
    let idsolicitado: any
    let fechasol: any
    let codigoC: any
    

    const fun1 = () => {          

                        
                                     
        ediciones=[]
        // loadEditions(codigo).then(function(result){
        //      result.forEach((element)=>{
        //         ediciones.push({text:element.fechas, value:element.edicion});
        //                         })
        //  });
        
        TiposTransXCta = [];
        transXCuenta(codigo).then(function(result){
            result.forEach((element)=>{
               TiposTransXCta.push({text:element.transacciones,value:element.id});
          })
        });        
     
                      
     } 

     loadExonDetail(props.idControl)



exoneracionDetail.map((exo)=>{
    actividad= exo.nombreCurso
    trans = exo.operacionesDetalle
    Nombres = exo.alumno
    razon = exo.razon_de_solicitud
    porcentaje = exo.porcentaje_de_solicitud
    codigo = exo.codigoCurso
    idalumno = exo.appUserIdAlumno
    idaprobado = exo.appUserIdAprobadoPor
    idsolicitado = exo.appUserIdSolicitadoPor
    fechasol= exo.fecha_de_solicitud
    codigoC= exo.codigoCurso    

})
        
   
    
    let TiposTransXCta:object[]=[];   
 
    let ActividadAcademica:object[]=[];

    let ediciones:object[]=[];

let estadoUno:any
const element : HTMLElement = document.getElementById('uno')  as HTMLElement ;
//const element2 : HTMLElement = document.getElementsByName('dos') as unknown as HTMLElement ;


  
const estadoExo = () => {
  estadoUno = 1;
};

const estadoExo2 = () => {
  estadoUno = -1;
};



    function handleFormSubmit(ExoneracioneMod : ExoneracionesModFormValues) {
     let date: Date = new Date();
    

         if(estadoUno == 1){

            let newExoneracion : ExoneracionesMod = {
                idcontrol : props.idControl,              
               
                catEdicionesId: codigoC,
                transacciones: 1,
                userAlumnoId :idalumno,
                aprobado_por : idaprobado,
                solicitado_por: idsolicitado,
                fecha_de_solicitud : fechasol,
                fecha_de_aprobacion : date,                     
                estado : 1,
                comentario : ExoneracioneMod.comentario,
                razon_de_solicitud : razon,
                porcentaje_de_solicitud : ExoneracioneMod.porcentaje_de_solicitud,   
                nombreCompletoAprobadopor : "",
                                          
            }    
            updateExoneracionMod(newExoneracion).then(() => {
         toast.success("Se actualizó correctamente.")
            modalStore.closeModal()
         })      

         }else {

            let newExoneracion : ExoneracionesMod = {
                idcontrol : props.idControl,               
                
                catEdicionesId: codigoC,
                transacciones: 1,
                userAlumnoId :idalumno,
                aprobado_por : idaprobado,
                solicitado_por: idsolicitado,
                fecha_de_solicitud : fechasol,
                fecha_de_aprobacion : date,                     
                estado : -1,
                comentario : ExoneracioneMod.comentario,
                razon_de_solicitud : razon,
                porcentaje_de_solicitud : ExoneracioneMod.porcentaje_de_solicitud,  
                nombreCompletoAprobadopor : "", 
                                          
            }  

            updateExoneracionMod(newExoneracion).then(() => {
         toast.success("Se actualizó correctamente.")
            modalStore.closeModal()
         }) 

         }     
            } 
       
              

   if (CuotasStore.loadingInitial) return <LoadingComponent content='Cargando...' />   

    return (
        
            <div className="pagina_formulario">                
                <Segment className="contenedor_formulario">               
                    <Formik 
                            enableReinitialize 
                            initialValues={ExoneracioneS} 
                            onSubmit={values => handleFormSubmit(values)}>                                
                        {({handleSubmit, isValid, isSubmitting, dirty}) => (
                            
                            <Form className='ui form' onSubmit={handleSubmit} autoComplete='on'>
                               
                                <Header size='large' content='Autorización de  Exoneración' style={{color:  "#538cbe", fontFamily: "Gotham"}} />                  <br></br>

                                
                                <div style={{marginBottom: "10px"}} >
                                    <Header size="small" content="Nombre del Alumno" />                                                                                                              
                                    

                                 <MyTextInput placeholder='' name="alumno" type="text" value={Nombres}></MyTextInput>                           
                                               
                                    </div>
                                     <br></br>       

                                <div style={{marginBottom: "10px"}} >
                                    <Header size="small" content="Actividad Académica" />
                                    <MyTextInput name='catCodigoCurso' placeholder='' value={actividad}   />
                                    
                                </div><br></br>

                                {/* <div>
                                    <Header size="small" content="Tipo de Transaccion" />
                                                                     
                                    <MySelectInput id="trnsacciones" name='transacciones' placeholder='' options={TiposTransXCta} />
                                    <Button onClick={fun1}></Button>

                                </div>  <br></br> */}
                                <div>
                                    <Header size="small" content="Tipo de Transaccion" />
                                                                     
                                    <MyTextInput  name='cctTiposdeTransaccionId' placeholder=''  value={trans} />
                                </div>  <br></br>                                     
                                                             
                                <div>
                                    <Header size="small" content="Razón de la solicitud" />
                                    <MyTextInput name='razon' placeholder='' value={razon}/>
                                </div>  <br></br>                                    

                                <div>
                                    <div className="porcent"><b>Porcentaje Solilcitado:    </b> <h3>{porcentaje}% </h3><br></br></div>
                                    <br></br>
                                    <div className="porcent">
                                    <b>Porcentaje Aprobado:    </b><MyTextInput className="porcentaje" name='porcentaje_de_solicitud' type="number" placeholder='25%,  50%,  75%  o  100%'/>
                                    </div>
                                    
                                </div>  <br></br>   

                                 <div>
                                    <Header size="small" content="Comentario" />
                                    <MyTextArea name='comentario' placeholder='' rows={3} />
                                     </div>  <br></br>  
                                                                           
                                                                                                           
                                <br></br>
                                <div className="botones">

                                    <button className="aprobar" style={{backgroundColor: "#15b3e8", color: "white", }} id="uno" name='uno' type="submit" onClick={estadoExo}>Aprobar</button>

                                    <button className="anular" style={{backgroundColor: "#f44336", color: "white", }} id="dos" name="dos" type="submit" onClick={estadoExo2}>Anular</button>
                                                                        
                                                             

                                       
                                </div>  

                                                                

                                
                            </Form>
                        )} 
                    </Formik>

                    
                    
                </Segment>
                
        </div>
    )
})